import React from "react";
import Navbar from "../components/Navbar";
import Features from "../components/Features";
import Pricing from "../components/Pricing";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

function EasyToUse() {
  return (
    <>
      <Helmet>
        <title>Easy-to-Use SEO Tools - Seotic</title>
        <meta
          name="description"
          content="Explore Seotic's easy-to-use SEO features and affordable pricing to boost your site's performance."
        />
      </Helmet>
      <Navbar />
      <section className="text-center py-20 bg-yellow-50">
        <h1 className="text-4xl font-bold mb-4">SEO Made Easy</h1>
        <p className="text-lg mb-8">Discover simple tools that help you rank higher and grow traffic.</p>
        <a
          href="https://app.seotic.co/register"
          className="bg-yellow-300 text-yellow-900 px-8 py-3 rounded-lg font-medium hover:bg-yellow-400"
        >
          Get Started Free
        </a>
      </section>
      <Features />
      <Pricing />
      <Footer />
    </>
  );
}

export default EasyToUse;